import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

// axios.defaults.baseURL = 'http://127.0.0.1:8000'

const { jwt } = useJwt(axios, {})
export default jwt
